<kt-base-modal [title]="'Shift'">
    <div modal-body>
        <div class="row">
            <div class="col-md-6 border-right">
                <div class="row">
                    <div class="col-md-12 form-group">
                        <kt-select [field]="formConstants.client_id" [form]="form" [options]="lookup.client">
                        </kt-select>
                    </div>
                    <div class="col-md-12 form-group">
                        <kt-select [field]="formConstants.location_id" [form]="form" [options]="lookup.location">
                        </kt-select>
                    </div>
                    <div class="col-md-12 form-group">
                        <kt-select [field]="formConstants.area_id" [form]="form" [options]="lookup.area">
                        </kt-select>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="block-wrapper comment-box">
                    <div class="block-title">Your Upcoming Shift</div>

                    <div class="kt-widget4 kt-widget-4">
                        <div class="kt-widget4__item" *ngFor="let shiftInfo of upcomingShifts()">
                            <div class="kt-widget4__info">
                                <div class="kt-widget4__username text-dark">Works at {{shiftInfo?.area?.area_name }}</div>
                                <div class="kt-widget4__text">
                                    <svg-icon class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/location.svg"></svg-icon>
                                    <span>{{shiftInfo?.location?.location_name }}</span>
                                    <svg-icon class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/client.svg"></svg-icon>
                                    <span>{{shiftInfo?.client?.client_name }}</span>
                                </div>
                                <div class="kt-widget4__text">
                                    <svg-icon class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/time.svg"></svg-icon>
                                    <span>{{(shiftInfo?.shift_start_date) | TimezoneDateTime }}</span> -
                                    <span>{{shiftInfo?.shift_end_date | TimezoneDateTime }}</span>
                                </div>
                            </div>

                            <button type="button" class="btn btn-sm btn-brand" (click)="viewDetailsClickHandler(shiftInfo)">
                View
              </button>

                            <!--<button type="button" class="btn btn-sm btn-warning ms-2" *ngIf="!shiftInfo.shift_offer_request_count && !shiftInfo.shift_swap_request_count
               && (shiftInfo?.location?.location_scheduling_allow_employees_to_offer_shifts_enable 
               || shiftInfo?.location?.location_scheduling_allow_employees_to_swap_shifts_enable)"
                (click)="cannotWorkHandler(shiftInfo)">
                Can't Work
              </button>

              <button type="button" class="btn btn-sm btn-success ms-2" *ngIf="shiftInfo.shift_offer_request_count"
                (click)="swapSentHandler(shiftInfo)">
                Shift Offer Sent
              </button>

              <button type="button" class="btn btn-sm btn-success ms-2" *ngIf="shiftInfo.shift_swap_request_count"
                (click)="dispatchGetShiftByIdForSwapSent({id: shiftInfo.shift_id})">
                Shift Swap Offer Sent
              </button> -->

                        </div>

                
                        <ng-container *ngIf="!upcomingShifts().length && !loading()">
                            <kt-no-record-found [noRecordFound]="noRecordFound"></kt-no-record-found>
                        </ng-container>

                    </div>
                </div>

            </div>
        </div>

        <div class="kt-login__actions d-flex align-items-center justify-content-between mt-5">
            <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
            </kt-button>
            <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" (buttonClick)="saveClickHandler()">
            </kt-button>

        </div>
    </div>
</kt-base-modal>